import endPoints from '../../config/endPoints';

export const PAYMENT_STATUS_CONTENT = {
  success: {
    image: endPoints.LYRA_PAYMENT_SUCCESS.URL,
    title: 'Payment Successful',
    subtitle: 'Thank you for your Transaction.',
    alt: endPoints.LYRA_PAYMENT_SUCCESS.ALT,
  },
  processing: {
    image: endPoints.LYRA_PAYMENT_PROCESSING.URL,
    title: 'Processing Payment',
    subtitle: 'Please wait while we process your payment.',
    alt: endPoints.LYRA_PAYMENT_PROCESSING.ALT,
  },
  failed: {
    image: endPoints.LYRA_PAYMENT_FAILED.URL,
    title: 'Payment Failed',
    subtitle: 'Your payment could not be processed.',
    alt: endPoints.LYRA_PAYMENT_FAILED.ALT,
  },
};



// WEBPACK FOOTER //
// client/containers/LyraPaymentStatus/constant.js